import { useDocumentStore } from '@roc/feature-documents';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Add, CloudUpload, CloudDownload, Menu } from '@material-ui/icons';
import { Box } from '@material-ui/core';
import { DropdownMenu, FileUpload, FileUploadModal } from '@roc/ui';
import { useState } from 'react';
import { observer } from 'mobx-react';
import { LoanProcess } from '@roc/feature-utils';
import { AddLoanTaskDialog, useGeneralTasksStore } from '@roc/feature-general-tasks';

const useStyles = makeStyles((theme: Theme) => ({
  menu: {
    marginRight: theme.spacing(2),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(0,0,0,0.15)',
  },
}));

export const SectionActions = observer(
  ({ loanProcess, sectionName, sectionId, loanId, drawId, isTaskFrameworkEnabled = false, payoffId, type2 = null, typeId2 = null, categoryDB = null }) => {
    const { documentStore } = useDocumentStore();
    const { loanTodosStore } = documentStore;
    const classes = useStyles();
    const { generalTasksStore } = useGeneralTasksStore();

    const [isUploadOpen, setUploadOpen] = useState(false);
    const [isAddTaskOpen, setAddTaskOpen] = useState(false);

    const onSectionDocumentsUpload = (files: FileUpload[]) => {
      if (loanProcess === LoanProcess.CLOSING && !isTaskFrameworkEnabled) {
        // TODO: Remove this if when implementing todos endpoint for closing tab
        documentStore.uploadSectionDocuments(
          files,
          loanId,
          sectionId,
          sectionName,
          loanProcess,
          null,
          drawId,
          payoffId,
          categoryDB ? categoryDB : undefined
        );
      } else {
        loanTodosStore.uploadSectionDocuments(
          files,
          loanId,
          sectionId,
          sectionName,
          loanProcess,
          drawId,
          payoffId,
          categoryDB ? categoryDB : undefined
        );
      }
    };

    const onSectionDownload = () => {
      documentStore.downloadAllFromSection({ categoryDB, loanId, sectionId, type2, typeId2 });
    };

    const closeFileUploadModal = () => {
      setUploadOpen(false);
    };

    const allowUpload = documentStore.isUploadAllowed(sectionName, loanProcess);
    const showDownloadAll = documentStore.showDownloadAll(sectionName);
    const isInternalPortal = documentStore.globalStore.isInternalPortal;

    const fetchTodos = () => {
      if (loanProcess === LoanProcess.TODOS) {
        documentStore.loanTodosStore.fetchTodosForMultipleLoanProcesses(loanId, loanProcess, [LoanProcess.UNDERWRITING, LoanProcess.CLOSING]);
      } else {
        documentStore.loanTodosStore.fetchTodos(loanId, loanProcess, null);
      }
    }

    const handleCloseAddTask = () => {
      fetchTodos();
      setAddTaskOpen(false);
    }

    const options = [
      isInternalPortal && {
        name: 'Add Task',
        action: () => setAddTaskOpen(true),
        icon: Add,
      },
      allowUpload && {
        name: 'Add New Documents',
        action: () => setUploadOpen(true),
        icon: CloudUpload,
      },
      showDownloadAll && {
        name: 'Download All Documents',
        action: () => onSectionDownload(),
        icon: CloudDownload,
      },
    ].filter(Boolean);

    return (
      <>
        {options.length > 0 && (
          <Box
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <DropdownMenu options={options} containerClass={classes.menu}>
              <Menu />
            </DropdownMenu>
          </Box>
        )}
        <FileUploadModal
          title={`ADD NEW DOCUMENTS: ${sectionName}`}
          open={isUploadOpen}
          multiple
          onClose={closeFileUploadModal}
          onUpload={files => onSectionDocumentsUpload(files)}
        />
        <AddLoanTaskDialog
          open={isAddTaskOpen}
          loanId={loanId}
          handleClose={() => handleCloseAddTask()}
          sectionName={categoryDB || sectionName}
          options={[{ value: sectionId, label: sectionName }]}
          sectionId={sectionId}
          loanProcess={loanProcess}
          type2={type2}
          typeId2={typeId2}
        />
      </>
    );
  }
);
